module.exports = __webpack_public_path__ + "img/Banner-image-AOV.110b4d0f.jpg";